import lazySizes from 'lazysizes';
import lazySizesUnveilhooks from 'lazysizes/plugins/unveilhooks/ls.unveilhooks';
import lazySizesBgset from 'lazysizes/plugins/bgset/ls.bgset';
import slickCarousel from 'slick-carousel';
import StickyNav from './components/StickyNav';

const images = require.context('./../img', true, /\.(png|jpe?g|svg)$/);
images.keys().forEach(images);

//Styles
import './../../node_modules/@fortawesome/fontawesome-pro/css/fontawesome.css';
import './../../node_modules/@fortawesome/fontawesome-pro/css/regular.css';
import './../../node_modules/@fortawesome/fontawesome-pro/css/brands.css';
import './../css/main.pcss';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

//Components
import './components/formFieldIsset';
import './components/InViewport';
import './components/blockLinks';
import './components/collapsable';
import './components/dropdown';
import './components/glanceTable';
import './components/glossary';
import './components/responsiveImg';


(function ($) {

  $(document).ready(function () {
    var pg_header = $('.pg-header'),
      pg_body = $('.pg-body'),
      pg_footer = $('.pg-footer');

    $('.collapsable').collapsable();
    $('.at-a-glance').glanceTable();
    $('.block-link').blockLinks();
    $('.entry-content').responsiveImg();
    $('.glossaryHighlighter .glossary-term').glossary();
    $('.dropdown').dropdown();


    //Legacy accordion initialized
    $('.accordion, .block-accordion').each(function () {
      var $accordion = $(this),
        singleOpen = $accordion.hasClass('single-open'),
        $panels = $accordion.find('.accordion-panel');

      $panels.collapsable({
        singleOpen: singleOpen
      });
    });



    var handle_ajax_form = function (e) {
      e.preventDefault();

      console.log('ajax form submitted');

      var $form = $(this),
        form_id = $form.attr('id'),
        baseUrl = $form.attr('action'),
        dataParams = $form.serializeArray(),
        $result_container = $form.closest('#results');

      //unset loaded flag
      $result_container.toggleClass('loading', true).toggleClass('loaded', false);

      // Send the data using post
      $.get(baseUrl, dataParams, function (data) {
        var content = $(data).find("#results > *");
        $result_container.empty().append(content);
        $result_container.find('.ajax-form').formFieldIsset();

        const queryString = $.param(dataParams);
        const newUrl = baseUrl + '?' + queryString;
        history.pushState(dataParams, '', newUrl);

        //set loaded flag
        $result_container.toggleClass('loading', false).toggleClass('loaded', true).trigger('loaded');
      });


    };
    pg_body.on('submit', '.ajax-form', handle_ajax_form);

    var handle_ajax_form_reset = function (e) {
      e.preventDefault();
      console.log('handle reset');
      var $form = $(this).closest('form'),
        baseUrl = $form.attr('action'),
        $result_container = $form.closest('#results');

      //unset loaded flag
      $result_container.toggleClass('loading', true).toggleClass('loaded', false);

      // Send the data using post
      $.get(baseUrl, function (data) {
        var content = $(data).find("#results > *");
        $result_container.empty().append(content);
        $result_container.find('.ajax-form').formFieldIsset();

        history.pushState({path: baseUrl}, '', baseUrl);
        //set loaded flag
        $result_container.toggleClass('loading', false).toggleClass('loaded', true).trigger('loaded');
      });
    }

    pg_body.on('click', '.form .form-btn-reset', handle_ajax_form_reset);

    pg_body.on('click', '.reset-form-filters', function (e) {
      e.preventDefault();
      console.log('reset filter button');
      var el = $(this),
        $form = $(el.attr('href')).find('.form');
      handle_ajax_form_reset.call($form, e);
    });


    pg_body.on('change', '.filter-form .filter', function () {
      console.log('change filter');
      var $form = $(this).closest('form');
      $form.submit();
    });


    $('body').on('click', '#refine_filters', function (e) {
      e.preventDefault();
      $(this).hide();
      $('.resource-nav').toggle('expanded', true);
    });

    $('.scroll_nav').each(function () {
      new StickyNav(this, {
        $container: $('.has-content-menu'),
        inset: 48,
        anchor: true
      });
    });

    //Panel Menu
    var handler_panelMenu = function (e) {
      e.preventDefault();

      var el = $(this),
        container = el.closest('.trigger-menu'),
        nav = el.closest('.navigation-wrapper'),
        classname = 'display-menu',
        is_header = nav.hasClass('header-primary-menu'),
        is_mobile = $(window).width() < 1024,
        is_hover = e.type === 'mouseenter';


      //reset other menus
      nav.find('.trigger-menu').not(container).removeClass(classname);
      if (is_header) pg_header.toggleClass('display-screen', false);

      if (container.hasClass('trigger-menu')) {
        nav.find('.open').not(el).not(".menu-toggle").removeClass('open');


        if (is_hover) {
          el.toggleClass('open', true);
          $(container).toggleClass(classname, true);
          if (is_header) $('body').toggleClass('no-scroll', true);
          if (is_header) pg_header.toggleClass('display-screen', true);
          if (is_header) pg_header.off('click', '.menu-fade-screen');
          if (is_header) pg_header.off('mouseenter', '.menu-fade-screen');
          $(document).off('mouseleave', 'html');
        } else {
          el.toggleClass('open');
          $(container).toggleClass(classname, el.hasClass('open'));
          if (is_header) $('body').toggleClass('no-scroll', el.hasClass('open'));

          if (!is_mobile) {
            if (is_header) pg_header.toggleClass('display-screen', el.hasClass('open'));
            if (is_header) pg_header.off('click', '.menu-fade-screen');
            if (is_header) pg_header.off('mouseenter', '.menu-fade-screen');
            $(document).off('mouseleave', 'html');

            //Toggle close any mobile menus
            $('.mobile-menu .menu-toggle.open').click();
          }
        }


      } else {
        nav.find('.open').removeClass('open');
        $('body').toggleClass('no-scroll', false);
        if (is_header) pg_header.toggleClass('display-screen', false);
      }

      $(container).one('click', '.menu-panel a', function (e) {
        if ($(this).attr('href') === '#') {
          $(container).toggleClass(classname, false);
          el.toggleClass('open', false);
          $('body').toggleClass('no-scroll', false);
          if (is_header) pg_header.toggleClass('display-screen', false);
        }
      });
      if (container.hasClass(classname)) {
        if (is_header) {
          pg_header.on('click', '.menu-fade-screen', function (e) {
            e.stopPropagation();
            console.log('.menu-fade-screen => click');
            if (e.target != this) return;
            pg_header.off('click', '.menu-fade-screen');
            pg_header.off('keydown');
            container.toggleClass(classname, false);
            el.toggleClass('open', false);
            $('body').toggleClass('no-scroll', false);
            pg_header.toggleClass('display-screen', false);
          });
          pg_header.on('keydown', function (e) {
            if (container.hasClass(classname) && (e.key === 'Escape' || e.keyCode === 27)) {
              pg_header.off('click', '.menu-fade-screen');
              pg_header.off('keydown');
              container.toggleClass(classname, false);
              el.toggleClass('open', false);
              $('body').toggleClass('no-scroll', false);
              pg_header.toggleClass('display-screen', false);
            }
          });
        }


        if (is_hover) {
          if (is_header) {
            pg_header.on('mouseenter', '.menu-fade-screen', function (e) {
              e.stopPropagation();
              console.log('.menu-fade-screen => mouseenter');
              if (e.target != this) return;
              pg_header.off('click', '.menu-fade-screen');
              pg_header.off('mouseenter', '.menu-fade-screen');
              $(document).off('mouseleave', 'html');
              $(container).toggleClass(classname, false);
              el.toggleClass('open', false);
              $('body').toggleClass('no-scroll', false);
              pg_header.toggleClass('display-screen', false);
            });
          }
          $(document).on('mouseleave', 'html, .navigation-wrapper', function (e) {
            e.stopPropagation();
            console.log('html => mouseleave');
            if (is_header) pg_header.off('click', '.menu-fade-screen');
            if (is_header) pg_header.off('mouseenter', '.menu-fade-screen');
            $(document).off('mouseleave', 'html');
            $(container).toggleClass(classname, false);
            el.toggleClass('open', false);
            $('body').toggleClass('no-scroll', false);
            if (is_header) pg_header.toggleClass('display-screen', false);
          });
        }
      }


    };
    pg_header.on('click', '#site-navigation > .nav-menu > .menu > .trigger-menu > a', handler_panelMenu);
    pg_header.on('click', '#site-navigation > .nav-menu > .mobile-lang-menu > .menu > .trigger-menu > a', handler_panelMenu);
    // pg_header.on('mouseenter', '#site-navigation > .nav-menu > .menu > .trigger-menu > a', handler_panelMenu);
    pg_footer.on('click', '#foot-navigation > .nav-menu > .menu > .trigger-menu > a', handler_panelMenu);


    pg_header.on('click', '#menu-search > a', function (e) {
      $(this).closest('.trigger-menu').find('.site-search-form input').focus();
    });


    //set isset attr & clear errors
    $('.form').formFieldIsset();


    //Scroll-link
    $('.scroll-link').on('click', function (event) {
      // On-page links
      if (
        (this.pathname === '/' && this.hash.length > 0) ||
        (location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '')
          &&
          location.hostname === this.hostname)
      ) {
        // Figure out element to scroll to
        var target = $(this.hash);
        target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');

        var scrollTop = $(window).scrollTop(),
          elementOffset = $(target).offset().top,
          distance = Math.abs(elementOffset - scrollTop),
          msPerDistance = .55,
          minRange = 300, //minimal animation time
          maxRange = 1500, //Maximal animation time
          speed = distance * msPerDistance,
          padding = 20;

        if ($(this).attr('data-padding') !== undefined) {
          padding = $(this).attr('data-padding');
        }

        speed = Math.min(speed, maxRange);
        speed = Math.max(speed, minRange);

        if (target.length) {
          event.preventDefault();
          $('html, body').animate({scrollTop: target.offset().top}, speed, "linear");
        }
      }
    });


    var activity_image = $('.activity-image');
    activity_image.on('mouseenter', 'label', function (e) {
      $(this).closest('figcaption').toggleClass('open', true);
    });
    activity_image.on('mouseleave', 'figcaption', function (e) {
      $(this).toggleClass('open', false);
    });

    //Site Search reset button
    $(' .site-search-form').on("click", ".form-btn-reset", function (e) {
      e.preventDefault();
      console.log("The form is being reset!");
      var $f = $(this).closest('form').find('input, textarea, select').not(':button, :submit, :reset, [type="hidden"]');

      $f.each(function () {
        var originalValue = $(this).val();
        console.log("Before clear:", originalValue);

        // Clear the value
        $(this).val("");
        console.log("After clear:", $(this).val());

        $(this).trigger('change');
      });

      var cleanURL = window.location.protocol + "//" + window.location.host + window.location.pathname + '?s=';
      if ($('#page').hasClass('search')) {
        window.location.href = cleanURL;
      }
      window.history.replaceState({path: cleanURL}, '', cleanURL);
    });


    // Enable menu toggle for small screens.
    $('.mobile-menu .menu-toggle').on('click', function (e) {
      e.preventDefault();

      var el = $(this),
        selector = $(this).attr('data-menu-container'),
        container = el.closest(selector),
        classname = $(this).attr('data-classname'),
        mobile_menu = el.closest('.mobile-menu'),
        btns = mobile_menu.find('.menu-toggle'),
        other_classnames = btns.map(function () {
          const name = $(this).data('classname');
          if (classname === name) {
            return null;
          }
          return name;
        }).get();

      if (classname === undefined) {
        classname = 'display-menu';
      }

      btns.not(el).removeClass('open');
      el.toggleClass('open');
      if (other_classnames.length > 0) {
        $(container).removeClass(other_classnames.join(' '));
      }
      $(container).toggleClass(classname);

      $('body').toggleClass('no-scroll-sm', el.hasClass('open'));

    });

    //Container tab nav
    $('.tab-container').each(function () {
      var container = $(this);

      $(this).on('click', '.tab-nav .tab-menu a', function (e) {
        e.preventDefault();
        var id = $(this).data('id'),
          title = $(this).text(),
          url = $(this).attr('href');

        container.find('.tab-nav .menu_title').empty().append(title);
        container.find('.tab-nav .tab-menu li').toggleClass('active', false);
        container.find('.tabs .tab').toggleClass('active', false);

        $(this).closest('li').toggleClass('active', true);
        container.find(id).toggleClass('active', true);
        container.find('.mobile-menu a').click();
        history.pushState({id: id}, '', url);
        $('html, body').animate({scrollTop: $(id).offset().top - 146}, 1200, "linear");

      });
    });

    $('.toggle-menu').each(function () {
      var container = $(this);
      $(this).on('click', '.toggle-button', function (e) {
        e.preventDefault();

        var btn = $(this),
          id = $(this).attr('href');

        container.find('.toggle-button').not(btn).toggleClass('active', false);
        btn.toggleClass('active', true);

        container.find('.toggle-content').toggleClass('active', false);
        container.find(id).toggleClass('active', true);
      });

    });


    //responsive video embeds
    var $allVideos = $("iframe[src*='player.vimeo.com'], iframe[src*='www.youtube.com'], object.video, embed.video");

    $allVideos.each(function () {
      $(this)
        // jQuery .data does not work on object/embed elements
        .attr('data-aspectRatio', this.height / this.width)
        .removeAttr('height')
        .removeAttr('width').wrap("<figure></figure>");
    });


    $(window).resize(function () {

      $allVideos.each(function () {

        var $el = $(this),
          $fluidEl = $el.closest('figure'),
          newWidth = $fluidEl.width();

        $el
          .width(newWidth)
          .height(newWidth * $el.attr('data-aspectRatio'));

      });

    }).resize();

  });

})(jQuery);

